<script setup>

import Table from "@/components/common/other/Table";
import Button from "@/components/common/input/Button"
import {inject} from 'vue';
import API from "@/classes/global/API";

const shipments = inject("shipments");

function openTracking(url) {

  window.open(url);
}

async function handleMacroPointLink(id) {

  let result = await API.getContainerMacroPointLink(id);

  if(result) window.open(result);

}
</script>

<template class="cmp-containers">

  <div class="cmp-containers-wrapper">
    <Table
        height="160"
        :selectable="false"
        :row-selection="false"
        :allow-grid-menu="false"
        :allowPagination="false"
        :columns="shipments.containers.gridColumns"
        :dataSource="shipments.viewShipment.containers">
      <template v-slot:tracking="row">
        <Button
            v-if="row.grid.showTracking"
            @click="openTracking(row.grid.trackingUrl)"
            type="secondary"
            text="Track">
        </Button>
      </template>
      <template v-slot:macropoint="row">
        <Button
            v-if="row.grid.macroPointOrderID"
            @click="handleMacroPointLink(row.grid.macroPointOrderID)"
            title="View This Container Within Micropoint"
            type="plain"
            text="View">
        </Button>
      </template>
    </Table>
  </div>

</template>

<style scoped>

.cmp-containers-wrapper {
  height: 170px;
}

</style>
